import axiosInstance from '@/store/axios';
import { rejectErrorApi } from '@/store/helper';

export default {
  state: {
    channel: null,
  },
  getters: {
    channel(state) {
      return state.channel;
    },
  },
  mutations: {
    setChannel(state, channel) {
      state.channel = channel;
    },
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    channels({ commit }, data) {
      const params = {
        $offset: data.offset || 0,
        $orderby: data.orderby || 'id',
      };
      if (data.limit) {
        params.$limit = data.limit;
      }
      if (data.expand) {
        params.$expand = data.expand;
      }
      if (data.ids) {
        params['id[in]'] = data.ids;
      }
      return axiosInstance.get('/api/v1/channels', { params })
        .then((result) => result.data.data)
        .catch((error) => Promise.reject(error));
    },
    // eslint-disable-next-line no-unused-vars
    getChannelById({ commit, state }, id, force = false) {
      if (state.channel && state.channel.id === id && !force) {
        return;
      }
      const params = {
        $expand: 'logo,timezone',
      };
      // eslint-disable-next-line consistent-return
      return axiosInstance.get(`/api/v1/channels/${id}`, { params })
        .then((result) => {
          commit('setChannel', result.data.data);
          return result.data.data;
        })
        .catch((error) => Promise.reject(error));
    },
    // eslint-disable-next-line no-unused-vars
    channelCount({ commit }, data) {
      const params = {};
      if (data.transcoderIds) {
        params['transcoder.id[in]'] = data.transcoderIds;
      }
      return axiosInstance.get('/api/v1/channels/$count', { params })
        .then((result) => result.data.data)
        .catch((error) => Promise.reject(error));
    },
    // eslint-disable-next-line no-unused-vars
    createChannel({ dispatch }, channel) {
      return axiosInstance({
        method: 'POST',
        url: '/api/v1/channels',
        data: channel,
      })
        .then((result) => result.data.data)
        .catch((error) => Promise.reject(error));
    },
    // eslint-disable-next-line no-unused-vars
    installChannel({ dispatch }, request) {
      return axiosInstance({
        method: 'POST',
        url: '/api/v1/channels/commands/install-channel',
        data: request,
      })
        .then((result) => result.data.data)
        .catch((error) => Promise.reject(error));
    },
    // eslint-disable-next-line no-unused-vars
    updateChannel({ dispatch }, channel) {
      return axiosInstance({
        method: 'PATCH',
        url: `/api/v1/channels/${channel.id}`,
        data: channel,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectErrorApi(error))
    },
    // eslint-disable-next-line no-unused-vars
    updateDummyEPG ({ dispatch }, data) {
      return axiosInstance({
        method: 'PUT',
        url: `/api/v1/channels/${data.channelId}/dummy-epg`,
        data: data.epg,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectErrorApi(error))
    },
    // eslint-disable-next-line no-unused-vars
    setAds ({ dispatch }, data) {
      return axiosInstance({
        method: 'PUT',
        url: `/api/v1/channels/${data.channelId}/ads`,
        data: data.ads,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectErrorApi(error))
    },
    // eslint-disable-next-line no-unused-vars
    contentDistribution ({ dispatch }, data) {
      return axiosInstance({
        method: 'GET',
        url: `/api/v1/channels/${data.channelId}/content-distribution`,
        data: data.ads,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectErrorApi(error))
    },
    // eslint-disable-next-line no-unused-vars
    deleteChannel ({ commit }, id) {
      return axiosInstance({
        method: 'DELETE',
        url: `/api/v1/channels/${id}`,
      })
        .then((result) => result.data)
        .catch((error) => Promise.reject(error));
    },
    //
    // eslint-disable-next-line no-unused-vars
    getTimezones({ dispatch }, params) {
      return axiosInstance.get('/setting/timezone/index')
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result);
          }
          return result.data.timezones || [];
        })
        .catch((error) => Promise.reject(error));
    },
    // eslint-disable-next-line no-unused-vars
    getLayouts({ dispatch }, params) {
      return axiosInstance.get('/channel/layout/index')
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result);
          }
          return result.data.layouts || [];
        })
        .catch((error) => Promise.reject(error));
    },
    // eslint-disable-next-line no-unused-vars
    getAnnouncements({ dispatch }, params) {
      return axiosInstance.get('/announcement/template/index')
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result);
          }
          return result.data.templates || [];
        })
        .catch((error) => Promise.reject(error));
    },
    // eslint-disable-next-line no-unused-vars
    getBlackouts({ dispatch }, params) {
      return axiosInstance.get('/blackout/template/index')
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result);
          }
          return result.data.templates || [];
        })
        .catch((error) => Promise.reject(error));
    },
    // eslint-disable-next-line no-unused-vars
    getChannels({ dispatch }, data) {
      if (!data) {
        // eslint-disable-next-line no-param-reassign
        data = {};
      }

      const params = {
        limit: data.limit || 100,
        offset: data.offset || 0,
        sort: data.sort || '-id',
      };

      return axiosInstance.get('/channel/index', {
        params,
      })
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result);
          }
          return result.data.channels || [];
        })
        .catch((error) => Promise.reject(error));
    },
    // eslint-disable-next-line no-unused-vars
    uploadChannelIcon({ dispatch }, file) {
      return axiosInstance.post('/channel/upload-icon', file, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result);
          }
          return result.data;
        })
        .catch((error) => Promise.reject(error));
    },
    // eslint-disable-next-line no-unused-vars
    createAutoSchedulerRules({ dispatch }, data) {
      return axiosInstance.post('/channel/auto-scheduler/rules/create', data)
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result);
          }
          return true;
        })
        .catch((error) => Promise.reject(error));
    },
    // eslint-disable-next-line no-unused-vars
    setAutoSchedulerRules({ dispatch }, data) {
      return axiosInstance.post('/channel/auto-scheduler/rules/update', data)
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result);
          }
          return true;
        })
        .catch((error) => Promise.reject(error));
    },
    // eslint-disable-next-line no-unused-vars
    disableAutoScheduler({ dispatch }, id) {
      return axiosInstance.get(`/channel/auto-scheduler/disable/${id}`)
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result);
          }
          return true;
        })
        .catch((error) => Promise.reject(error));
    },
    // eslint-disable-next-line no-unused-vars
    enableAutoScheduler({ dispatch }, id) {
      return axiosInstance.get(`/channel/auto-scheduler/enable/${id}`)
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result);
          }
          return true;
        })
        .catch((error) => Promise.reject(error));
    },
    // eslint-disable-next-line no-unused-vars
    getOverview({ dispatch }) {
      return axiosInstance.get('/statistic/dashboard')
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result);
          }
          return result.data.stat || {};
        })
        .catch((error) => Promise.reject(error));
    },
  },
};
